import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["type", "scroll", "locale", "pagination", "expandable", "className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import classNames from 'classnames';
import DixuButton from "../DixuButton/DixuButton";
import DixuEmpty from "../DixuEmpty/DixuEmpty";
import { itemRender } from "../DixuPagination/DixuPagination";
import React from 'react';
const DixuTable = _ref => {
  let {
      type,
      scroll,
      locale,
      pagination,
      expandable,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-table', className, {
    [`dixu-table--type-${type}`]: type
  });
  return /*#__PURE__*/React.createElement(Table, _extends({}, _objectSpread({
    className: classes,
    scroll: _objectSpread({
      scrollToFirstRowOnChange: true,
      x: '100%'
    }, scroll),
    locale: _objectSpread({
      emptyText: /*#__PURE__*/React.createElement(DixuEmpty, null)
    }, locale),
    pagination: (() => {
      if (!pagination) {
        return false;
      }
      return _objectSpread(_objectSpread({}, pagination), {}, {
        itemRender,
        size: 'default',
        className: classNames('dixu-pagination', pagination?.className)
      });
    })(),
    expandable: (() => {
      if (!expandable) {
        return undefined;
      }
      return _objectSpread({
        expandIcon: _ref2 => {
          let {
            expandable: rowExpandable,
            expanded,
            onExpand,
            record
          } = _ref2;
          if (!rowExpandable) {
            return null;
          }
          if (expanded) {
            return /*#__PURE__*/React.createElement(DixuButton, {
              type: "link",
              modifierType: "circle",
              icon: /*#__PURE__*/React.createElement(MinusCircleOutlined, null),
              onClick: event => onExpand(record, event)
            });
          }
          return /*#__PURE__*/React.createElement(DixuButton, {
            type: "link",
            modifierType: "circle",
            icon: /*#__PURE__*/React.createElement(PlusCircleOutlined, null),
            onClick: event => onExpand(record, event)
          });
        }
      }, expandable);
    })()
  }, rest), rest));
};
DixuTable.defaultProps = {
  type: 'default'
};
export default DixuTable;